export default () => ({
  rootContainer: {
    position: "relative",
    background: "#f9f9f9",
    flex: 1,
    // minHeight: "calc(100vh - 128px)",//`calc(${window.innerHeight}px - 64px)`,
    padding: 30,
    // minHeight: "calc(100vh - 163px)"
  },
  fieldContainer: {
    marginTop: "12px"
  },
  subHeader: {
    fontSize: 14,
    color: "black",
    fontFamily: "Open Sans",
    width: 509,
    height: 20
  },
  footer: {
    fontSize: 14,
    color: "grey",
    fontFamily: "Open Sans",
    width: 602,
    height: 40,
    margin: "20px 0"
  },
  textField: {
    width: 250,
    height: 40,
    marginTop: 20
  },
  buttonContainer: {
    display: "flex",
    width: 660,
    justifyContent: "flex-end",
    marginTop: 20
  },
  cancelButton: {
    color: "Gray"
  },
  sendButton: {
    boxShadow: "none"
  },
  sentSuccess: {
    color: "#66D184",
    fontWeight: "bold",
    marginRight: 12,
    marginLeft: 12
  },
  flexBox: {
    display: "flex",
    alignItems: "center"
  },
  testForm: {
    paddingBottom: 20
  },
  sendForApproval: {
    marginTop: 12,
    fontSize: 14,
    textAlign: "end"
  },
  button: {
    height: "40px !important",
    textTransform: "none",
    marginTop: 24
  },
  dateAlign: {
    textAlign: "end",
    fontSize: 16
  },
  dateMargin: {
    marginBottom: 12,
  },
  brokersList: {
    fontSize: 14,
    textAlign: "end",
  },
  hrLine: {
    width: 580,
    height: 1,
    background: "#EEEEEE",
    margin: "20px 0px"
  },
  innerExpansionContainer: {
    marginTop: "16px !important"
  },
  accessLink: {
    fontSize: 14,
    color: "#4F6FAE",
    marginLeft: 16,
    cursor: "pointer",
    fontWeight: 600
  },
  accountContainer: {
    paddingLeft: 40
  },
  removeButtons: {
    display: "flex",
    alignItems: "center",
  },
  removeButton: {
    fontSize: 14,
    color: "#4F6FAE !important",
    marginLeft: 8,
  },
  userName: {
    fontSize: 14,
    marginLeft: 8
  },
  imageContainer: {
    height: 24,
    width: 24,
    borderRadius: 12
  },
  flexBoxButtons: {
    display: "flex",
    alignItems: "center",
    height: 30,
    cursor: "pointer",
    marginTop: 10,
    marginRight: 15
  },
  emailItem: {
    padding: "2px 8px",
    height: 28,
    border: "1px solid #EEEEEE",
    marginRight: 12,
    marginTop: 16
  },
  emailflex: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    width: 552,
  },
  textApprover: {
    marginTop: 12,
    height: 40,
    fontSize: 14,
    color: "rgba(51,51,51,0.75)",
  },
  divider: {
    marginTop: 25,
    marginBottom: 20,
    background: "#EEEEEE",
    height: 1,
    width: "100%"
  },
  approversExpansion: {
    marginTop: 30
  },
  // textField: {
  //   height: 40,
  //   marginTop: 15
  // },
  headerIcon: {
    marginLeft: 8,
    height: 26,
    width: 23,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 12,
    background: "#F9F9F9"
  },
  disabledStyle: {
    pointerEvents: "none",
    opacity: 0.5
  },
  displayFlexIcons: {
    display: "flex",
    alignItems: "end",
    justifyContent: "flex-end"
  },
  rightPart: {
    width: "max-content"
  }
})